import { upsertUseCase } from "../usecases/object";
export const getAllDatesFromRanges = (arr) => {
    if (!Array.isArray(arr)) return [];
    
    const allDates = [];
    
    const process = (item) => {
      if (Array.isArray(item) && item.length === 2 && typeof item[0] === 'string' && typeof item[1] === 'string') {
        const start = new Date(item[0]);
        const end = new Date(item[1]);
        const current = new Date(start);
        
        while (current <= end) {
          allDates.push(current.toISOString().split('T')[0]);
          current.setDate(current.getDate() + 1);
        }
      } 

      else if (Array.isArray(item)) {
        item.forEach(process);
      } 
      else if (typeof item === 'string') {
        allDates.push(item);
      }
    };
    
    arr.forEach(process);
    return allDates;
  };

  export const buildDateConditions = (dateStrings) => {
    return dateStrings.map(dateStr => {
      const startDate = new Date(dateStr + 'T00:00:00.000Z').toISOString();
      const endDate = new Date(new Date(dateStr).getTime() + 24 * 60 * 60 * 1000).toISOString();
      return {
        date: {
          $gte: startDate,
          $lt: endDate,
        },
      };
    });
  }

  export const  batchUpdateDTRRecords = async (dtrRecords, status = "", batchSize = 50) => {
    for (let i = 0; i < dtrRecords.length; i += batchSize) {
      const batch = dtrRecords.slice(i, i + batchSize);

      const promises = batch.map((dtr) => {
        const stats = Array.isArray(dtr.timeRecStats)
          ? new Set(dtr.timeRecStats)
          : new Set();

        stats.add(status);

        return upsertUseCase().execute("daily_time_record", {
          id: dtr.id,
          timeRecStats: [...stats],
        });
      });

      await Promise.all(promises);
    }
  }